/*eslint-disable no-unsafe-optional-chaining */
/*eslint-disable no-unused-vars */
/*eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import PrimaryButton from '../../../common/button';
//import CheckboxInput from '../../../common/Checkbox';
import RadioInput from '../../../common/radio';
import FilterModal from '../../../common/filter-modal/FilterModal';
import { CoveredSlider } from './CoveredSlider';
import {
  GENDER_OPTIONS,
  PC_DISTANCE_OPTIONS,
  PROVIDER_SERVICES_OPTIONS,
  PROVIDER_OPTIONS,
} from '../../../../../constants/index';
import {
  setSearchProviderParams,
  resettingMoreFilters,
} from '../../../../../redux/admin/priceCompareSlice';
//import { genderOptions, distanceOptions, specialtiesOptions, providerServicesOptions } from '../../data/constants';
import { t } from 'i18next';
import CheckboxInput from '../../../../components/common/Checkbox';

const AllFilterOptions = ({ onApply, isVisible, onHide }) => {
  const dispatch = useDispatch();
  const allFilters = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin?.searchProviderParams?.filters,
  );
  const { AcceptingNewPatients } = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin?.searchProviderParams,
  );
  const {
    Gender,
    maximumradius,
    spokenlanguages,
    SameDayAppoinmentAvailable,
    specialities,
    Provider,
  } = allFilters;
  const filtersValuesList = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin?.filtersValuesList,
  );
  const languageOptions = filtersValuesList?.ListOfDoctorLanguages;
  const specialtiesOptions = filtersValuesList?.Specialities;
  //const providerServicesOptions = filtersValuesList.ProviderServices;
  //const searchProviderFiltersChanged = useSelector(({ findProvider }) => findProvider.searchProviderFiltersChanged);

  const [selectedOptions, setSelectedOptions] = useState({
    Gender,
    maximumradius,
    spokenlanguages,
    AcceptingNewPatients,
    SameDayAppoinmentAvailable,
    specialities,
    Provider,
  });

  useEffect(() => {
    setSelectedOptions({ ...allFilters });
  }, [allFilters]);
  const { DoctorByType } = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams,
  );

  const onChangePatient = (paramName, value) => {
    dispatch(setSearchProviderParams({ [paramName]: value }));
    setSelectedOptions({ ...selectedOptions, [paramName]: value });
  };
  const onChange = (paramName, value) => {
    if (paramName !== 'spokenlanguages') {
      if (paramName == 'specialities') {
        const existingIndex = selectedOptions?.specialities?.findIndex(
          (ele) => ele === value,
        );
        if (existingIndex > -1) {
          const updatedSpecialities = [...selectedOptions];
          updatedSpecialities.splice(existingIndex, 1);
          setSelectedOptions({
            ...selectedOptions,
            updatedSpecialities,
          });
        } else {
          const currentSelectedState = { ...selectedOptions };
          if (currentSelectedState?.specialities) {
            const existingIndexChild =
              currentSelectedState.specialities?.findIndex(
                (ele) => ele === value,
              );
            if (existingIndexChild > -1) {
              currentSelectedState.specialities.splice(existingIndexChild, 1);
            } else {
              const currentSpecalities = [...currentSelectedState.specialities];
              currentSpecalities.push(value);
              currentSelectedState.specialities = currentSpecalities;
            }
          } else {
            if (DoctorByType?.length > 0) {
              currentSelectedState.specialities = [value].concat(DoctorByType);
            } else {
              currentSelectedState.specialities = [value];
            }
          }
          setSelectedOptions(currentSelectedState);
        }
      } else {
        setSelectedOptions({ ...selectedOptions, [paramName]: value });
      }
    }
    if (paramName === 'spokenlanguages') {
      //console.log('selectedOptions >>>', selectedOptions);
      //console.log('selected value >>>', value);
      const valueIndex = selectedOptions.spokenlanguages
        ? selectedOptions.spokenlanguages.findIndex((lang) => lang === value)
        : -1;
      //console.log('valueIndex >>>', valueIndex)
      let finalLanguages = selectedOptions.spokenlanguages
        ? [...selectedOptions.spokenlanguages]
        : [];
      if (valueIndex > -1) {
        finalLanguages.splice(valueIndex, 1);
      } else {
        finalLanguages = [...finalLanguages, value];
      }
      setSelectedOptions({ ...selectedOptions, [paramName]: finalLanguages });
    }
  };

  const resetFilterHandler = (event) => {
    event.preventDefault();
    dispatch(resettingMoreFilters());
  };

  return (
    <>
      <FilterModal
        titleLabel={'Filters'}
        isVisible={isVisible}
        onHide={onHide}
        applyFilterHandler={() => {
          onApply(selectedOptions);
        }}
        customClasses="provider-filters-modal"
        showClearFilter={true}
        resetFilter={(event) => {
          resetFilterHandler(event);
        }}
        showClearFilterLabel="RESET"
        showBackButton={false}
        showCancel={true}
      >
        <div className="all-filter-options-admin">
          <div className="gender-options">
            <p>{t('find_provider.providers')}</p>

            {PROVIDER_OPTIONS.map((provider, index) => {
              return (
                <RadioInput
                  //inline

                  key={index}
                  label={provider.label}
                  name="providers"
                  className="cursor-pointer d-flex"
                  value={provider.value}
                  id={`provider-${index}`}
                  checked={selectedOptions.Provider === provider.value}
                  onChange={(e) => {
                    onChange('Provider', provider.value);
                  }}
                />
              );
            })}
          </div>

          {Provider !== 'facility' && (
            <div className="gender-options">
              <p>{t('find_provider.gender')}</p>

              {GENDER_OPTIONS.map((gender, index) => {
                return (
                  <RadioInput
                    //inline

                    key={index}
                    label={gender.label}
                    name="gender"
                    className="cursor-pointer d-flex"
                    value={gender.value}
                    id={`gender-${index}`}
                    checked={selectedOptions.Gender === gender.value}
                    onChange={(e) => {
                      onChange('Gender', gender.value);
                    }}
                  />
                );
              })}
            </div>
          )}

          {/*<div>

            <p>

              {t('member.price_comparison.provider_container.covered_cost')}

            </p>

            <CoveredSlider />

          </div> */}

          <div className="distance-options">
            <p>{t('find_provider.distance')}</p>

            {PC_DISTANCE_OPTIONS.map((distance, index) => {
              return (
                <RadioInput
                  //inline

                  key={index}
                  label={distance.label}
                  name="distance"
                  className="cursor-pointer d-flex"
                  value={distance.value}
                  id={`distance-${index}`}
                  checked={selectedOptions.maximumradius === distance.value}
                  onChange={(e) => {
                    onChange('maximumradius', distance.value);
                  }}
                />
              );
            })}
          </div>

          {languageOptions?.length > 0 && (
            <div className="language-options">
              <p>{t('find_provider.language_spoken')}</p>

              {languageOptions.map((language, index) => {
                return (
                  <CheckboxInput
                    //inline

                    key={index}
                    label={language.label}
                    className="cursor-pointer d-flex"
                    value={language.value}
                    id={`language-${index}`}
                    name="languages[]"
                    onChange={(e) => {
                      onChange('spokenlanguages', language.value);
                    }}
                    checked={
                      selectedOptions.spokenlanguages
                        ? selectedOptions.spokenlanguages.findIndex(
                            (lang) => lang === language.value,
                          ) > -1
                        : false
                    }
                  />
                );
              })}
            </div>
          )}

          {specialtiesOptions?.length > 0 && (
            <div className="speacility-options">
              <p>{t('find_provider.specialties')}</p>

              {specialtiesOptions.map((speacility, index) => {
                return (
                  <CheckboxInput
                    //inline

                    key={index}
                    label={speacility.label}
                    value={speacility.value}
                    className="cursor-pointer d-flex"
                    id={`speciality-${index}`}
                    onChange={(e) => {
                      onChange('specialities', speacility.value);
                    }}
                    checked={
                      DoctorByType?.length > 0 &&
                      DoctorByType == speacility.value
                        ? true
                        : selectedOptions.specialities
                        ? selectedOptions.specialities.findIndex(
                            (sp) => sp === speacility.value,
                          ) > -1
                        : false
                    }
                    {...(DoctorByType?.length > 0 &&
                    DoctorByType == speacility.value
                      ? { isDisabled: true }
                      : {})}
                  />
                );
              })}
            </div>
          )}

          {
            <div className="speacility-options">
              <p>{t('find_provider.provider_services')}</p>

              {PROVIDER_SERVICES_OPTIONS.map((service, index) => {
                return (
                  <CheckboxInput
                    //inline

                    key={index}
                    label={service.label}
                    checked={AcceptingNewPatients == true ? true : false}
                    className="cursor-pointer d-flex"
                    id={`provider-services-${index}`}
                    onChange={(e) => {
                      onChangePatient('AcceptingNewPatients', e.target.checked);
                    }}
                  />
                );
              })}
            </div>
          }
        </div>
      </FilterModal>
    </>
  );
};
export default AllFilterOptions;
